import { configureStore } from '@reduxjs/toolkit'
import { Action, ThunkAction } from '@reduxjs/toolkit'

import checkoutReducer from '@/features/Checkout/store/checkoutSlice'

const store = configureStore({
  reducer: {
    checkout: checkoutReducer
  }
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

export default store
